import React from "react";
import { RegisterOptions } from "react-hook-form";
import { FormItem, AutocompleteField } from "..";
import { AutocompleteControlProps } from "./AutocompleteControl.types";
import { GetChildrePropsParams } from "../FormItem/FormItem.types";

function AutocompleteControl(props: AutocompleteControlProps) {
  const {
    defaultValue,
    getAutocompleteFieldProps,
    hideHelperText,
    label,
    name,
    onChangeValue,
    required,
    validate,
    valuePropName,
    ...other
  } = props;

  const rules = React.useMemo<RegisterOptions>(() => {
    const result: RegisterOptions = {
      validate,
    };
    if (required) {
      result.required = {
        value: true,
        message: label ? `${label} is required` : "Required field",
      };
    }
    return result;
  }, [label, required, validate]);

  const getChildrenProps = React.useCallback(
    (params: GetChildrePropsParams) => {
      return getAutocompleteFieldProps?.(params);
    },
    [getAutocompleteFieldProps]
  );

  return (
    <FormItem
      defaultValue={defaultValue}
      getChildrenProps={getChildrenProps}
      hideHelperText={hideHelperText}
      name={name}
      onChangeValue={onChangeValue}
      rules={rules}
      valuePropName={valuePropName}
    >
      <AutocompleteField {...other} label={label} />
    </FormItem>
  );
}

export default React.memo(AutocompleteControl);
